/* global Foundation */
/* eslint no-magic-numbers: "off"*/

import animateScrollTo from "animated-scroll-to";
const chr = window.chrGlobal;

const getUrlParameter = ( sParam ) => {
  let sPageURL = window.location.search.substring( 1 ),
      sURLVariables = sPageURL.split( '&' ),
      sParameterName,
      index;

  for ( index = 0; index < sURLVariables.length; index++ ) {
    sParameterName = sURLVariables[ index ].split( '=' );

    if ( sParameterName[0] === sParam ) {
      return sParameterName[1] === undefined ?
        true : decodeURIComponent( sParameterName[1]);
    }
  }
};

const submitTagFilterForm = () => {

  jQuery( '.support-tabs__content__wrapper .tag-filter-form' )
    .on( 'change', 'input:checkbox', () => {
      jQuery( '.support-tabs__content__wrapper .tag-filter-form' ).submit();
    });

};

const updateImgWidth = () => {

  if ( ! Foundation.MediaQuery.is( 'large' ) ||
    ! jQuery( '.blog-image-section .image-wrapper' ).length
  ) {
    return;
  }

  let imgWidth = jQuery( window ).width() -
    jQuery( '.blog-image-section .image-wrapper' ).offset().left;

  jQuery( '.blog-image-section .image-wrapper' ).css( 'width', imgWidth );

};

const toggleRpCategories = () => {

  jQuery( '.categories-rp-label' ).click( ( event ) => {
    jQuery( event.currentTarget ).toggleClass( 'opened' );
    jQuery( event.currentTarget ).next().slideToggle();
  });

};

const scrollToBlog = () => {

  if ( getUrlParameter( 'article_s' ) || getUrlParameter( 'tags%5B%5D' ) ) {

    if ( jQuery( '#wpadminbar' ).length ) {
      chr.headerHeightDesk = chr.headerHeightDesk + 32;
    }

    animateScrollTo( document.querySelector( '.support-tabs' ), {
      offset:
        ( window.innerWidth < chr.mobileNavBreak ) ? -chr.headerHeightMob : -chr.headerHeightDesk,
      speed: 1000,
    });

  }

};

jQuery( () => {
  submitTagFilterForm();
  toggleRpCategories();
  scrollToBlog();

  jQuery( window ).resize( () => {

    updateImgWidth();

  }).resize();

});
